__turbopack_context__.v({
  "section": "article-paragraph-module-scss-module__tpXHTG__section",
});
